import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_rounded--common _pos-r" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "gfu-comment-user-profile-card-info _fo _flexcol" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "gfu-comment-user-profile-card-info__followers",
  "data-qa": "user-profile-content:followers-label"
}
const _hoisted_7 = {
  class: "_tc--lighter",
  "data-qa": "user-profile-content:bio"
}
const _hoisted_8 = { class: "_flexcol _mt-2 _gap-3" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "gfu-link-underline__content" }
const _hoisted_11 = {
  key: 1,
  "data-qa": "user-profile-content:private-profile-text"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_comment_user_profile_card = _resolveComponent("skeleton-comment-user-profile-card")
  const _component_base_avatar = _resolveComponent("base-avatar")
  const _component_icon_base_label = _resolveComponent("icon-base-label")
  const _component_user_follow_button = _resolveComponent("user-follow-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "gfu-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        ($props.isProcessing)
          ? (_openBlock(), _createBlock(_component_skeleton_comment_user_profile_card, {
              key: 0,
              "data-qa": "user-profile-content:skeleton"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(['gfu-media _gap-1', {'_ai-c': !$options.hasPledgeMasterBadge}])
              }, [
                _createElementVNode("a", { href: $props.profileUrl }, [
                  _createVNode(_component_base_avatar, {
                    "avatar-url": $props.avatarImageUrl,
                    alt: $props.nickname,
                    size: "sm",
                    clean: true,
                    class: "_mr-1",
                    "data-qa": "user-profile-content:avatar-image"
                  }, null, 8 /* PROPS */, ["avatar-url", "alt"])
                ], 8 /* PROPS */, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("a", {
                    href: $props.profileUrl,
                    class: "gfu-link--nofx"
                  }, [
                    _createElementVNode("h2", {
                      class: _normalizeClass(['gfu-hd gfu-hd--h1 _tc--base _toe', {'_mt-1': !$props.isPublic}]),
                      "data-qa": "user-profile-content:nickname"
                    }, _toDisplayString($props.nickname), 3 /* TEXT, CLASS */)
                  ], 8 /* PROPS */, _hoisted_5),
                  ($props.isPublic)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($options.formattedFollowersLabel), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.labels, (label) => {
                    return (_openBlock(), _createBlock(_component_icon_base_label, _mergeProps({
                      key: label.name
                    }, { ref_for: true }, label, {
                      class: "_mt-1",
                      "data-qa": `user-profile-content:${label.dataQa}`
                    }), null, 16 /* FULL_PROPS */, ["data-qa"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ], 2 /* CLASS */),
              ($props.isPublic)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString($props.bio), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_8, [
                      ($options.isFollowingButtonVisible)
                        ? (_openBlock(), _createBlock(_component_user_follow_button, {
                            key: 0,
                            nickname: $props.nickname,
                            "user-url-name": $props.urlName,
                            "user-id": $props.userID,
                            onAction: $options.onUserFollowAction,
                            "data-qa": "user-profile-content:follow-button"
                          }, null, 8 /* PROPS */, ["nickname", "user-url-name", "user-id", "onAction"]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("a", {
                        href: $props.profileUrl,
                        class: "gfu-link gfu-link-underline gfu-link--accent _tac",
                        "data-qa": "user-profile-content:view-profile-link"
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.Resources.Profile.ViewProfile), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_9)
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.Resources.Profile.CommentUserProfilePrivateStateParagraph), 1 /* TEXT */))
            ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}